<div class="tp-page tp-page--compact tp-list-page">
  <section class="tp-card tp-card--flush">
    <tp-page-header
      variant="toolbar"
      title="Puntos de venta"
      [subtitle]="companyName ? companyName + ' · ' + pointsOfSales.length + (pointsOfSales.length === 1 ? ' punto de venta' : ' puntos de venta') : ''"
    >
      <button id="addButton" mat-flat-button actions type="button" (click)="dialogAction()">
        <mat-icon>add</mat-icon>
        Nuevo punto de venta
      </button>
    </tp-page-header>
    @if (pointsOfSales.length === 0) {
      <tp-empty-state
        icon="storefront"
        title="Todavía no hay puntos de venta"
        message="Creá el primero con «Nuevo punto de venta»."
      ></tp-empty-state>
    } @else {
      <ul class="psl-list">
        @for (pos of pointsOfSales; track pos) {
          <li class="psl-row">
            <span class="psl-name">{{ pos.description }}</span>
            <app-icon-menu-button [menu]="menu" label="Acciones del punto de venta"></app-icon-menu-button>
            <mat-menu #menu="matMenu" xPosition="before">
              <button id="editButton" mat-menu-item (click)="dialogAction(pos)">
                Editar
              </button>
              <button id="editButton" mat-menu-item (click)="deletePointSale(pos.id.toString())">
                Eliminar
              </button>
            </mat-menu>
          </li>
        }
      </ul>
    }
  </section>
</div>
